import {QuestionId} from '../insurance/question-id';
import {QuestionnaireId} from '../insurance/questionnaire-id';
import {HealthAnswers} from '../questionnaire/health-answers';

export interface HealthAnswersRevision {
  id: string;
  type: HealthAnswersRevisionType;
  isAutoGenerated: boolean;
  revision: PresetRevision | CustomRevision;
  createdAt: Date;
  completedAt?: Date;
  isIncludedInContract: boolean;
}

export interface PresetRevision {
  questionnaires: {questionnaireId: QuestionnaireId; referenceQuestionId?: QuestionId}[];
  answers?: HealthAnswers;
}

export interface CustomRevision {
  question: string;
  answer?: string;
  documentNames?: string[];
}

export enum HealthAnswersRevisionType {
  PRESET = 'PRESET',
  CUSTOM = 'CUSTOM',
}

export function getPresetRevisions(healthAnswersRevisions: HealthAnswersRevision[]): PresetRevision[] {
  return healthAnswersRevisions
    .filter((har) => har.type === HealthAnswersRevisionType.PRESET)
    .map((har) => har.revision as PresetRevision);
}

export function getCustomRevisions(healthAnswersRevisions: HealthAnswersRevision[]): CustomRevision[] {
  return healthAnswersRevisions
    .filter((har) => har.type === HealthAnswersRevisionType.CUSTOM)
    .map((har) => har.revision as CustomRevision);
}
